import React from 'react';
import type { JobStatus as NumericJobStatus } from '../../../app/ApiGen';
import { JobStatus } from '../../../app/enums';
import { HumanReadableJobStatus } from '../../../components/CustomFields/JobStatus';
import { SelectableFilters, truncateAppliedFilters } from './SelectableFilters';
import { FilterComponentProps } from './types';

type StatusFilterValues = Record<`${NumericJobStatus}`, boolean>;

const defaultFilters: StatusFilterValues = {
  [JobStatus.Pending]: true,
  [JobStatus.Error]: true,
  [JobStatus.Complete]: false,
  [JobStatus.Commissioning]: true,
  [JobStatus.ManuallyCommissioned]: false,
  [JobStatus.Cancelled]: false,
  [JobStatus.InProgress]: true,
};

function renderValues(value: [string, boolean][]): string {
  return truncateAppliedFilters(
    value.flatMap(([filterKey, filterApplied]) => {
      if (!filterApplied) return [];
      const jobStatusKey = parseInt(filterKey, 10) as NumericJobStatus;
      return [HumanReadableJobStatus[jobStatusKey]];
    }),
  );
}

export const JobStatusFilters: React.FC<FilterComponentProps> = ({ columnDef, onFilterChanged }) => (
  <SelectableFilters<NumericJobStatus, StatusFilterValues>
    columnDef={columnDef}
    defaultFilters={defaultFilters}
    onFilterChanged={onFilterChanged}
    options={Object.entries(HumanReadableJobStatus)}
    renderValues={renderValues}
  />
);
